module.exports = __webpack_public_path__ + "static/media/0324_IMG_LE_SOL_MEGALITH_MEGABROWN.d4084520.png";